module.exports = __webpack_public_path__ + "media/img/frontend_application/coupon-orange-7756b5fa24ae61364fd5080e147ce2e4.png";